<birdz-card [isLoading]="isLoading > 0" [isEmpty]="(hasPerimeter$ | async) !== true || kpis.length === 0">
  <div card-title>
    {{ 'TAB_KPI_MAP' | transloco }}
  </div>
  <div card-subtitle>
    <birdz-period-display></birdz-period-display>
  </div>
  <div card-corner>
    @if ((hasPerimeter$ | async) === true && kpis.length > 0) {
      <button
        matIconButton
        class="corner-help-button bdz-mat-icon-button-info"
        [matTooltip]="'CONTRACT_CONFIG_HELP.TITLE' | transloco"
        (click)="openContractKpiHelp()"
      >
        <mat-icon>question_mark</mat-icon>
      </button>
    }
  </div>
  <div card-empty>
    @if ((hasPerimeter$ | async) === true && kpis.length === 0) {
      {{ 'MISSING_KPI_CONFIG_FOR_CONTRACT_PART_1' | transloco }}<br />
      {{ 'MISSING_KPI_CONFIG_FOR_CONTRACT_PART_2' | transloco }}
    } @else {
      {{ 'PLEASE_SELECT_A_CONTRACT' | transloco }}
    }
  </div>
  <div card-body class="body">
    <div class="controls">
      <!-- time navigation -->
      <birdz-period-prev-next>
        <birdz-period-picker
          [granularities]="granularities"
          [disabledGranularities]="disabledGranularities"
          [shortcuts]="shortcuts"
          [disabledShortcuts]="disabledShortcuts"
        ></birdz-period-picker>
      </birdz-period-prev-next>

      <!-- kpis -->
      <mat-form-field>
        <mat-label>{{ 'KPIS' | transloco }}</mat-label>
        <mat-select [(ngModel)]="selectedKpi" (selectionChange)="onKpiSelectionChange($event)">
          @for (kpi of kpis; track kpi) {
            <mat-option [value]="kpi.id" [class]="{ 'birdz-admin': kpi.admin_birdz_display }">
              {{ kpi.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    @if (undisplayableSelectedKpiMessage) {
      <birdz-alert type="warning" icon="warning">
        {{ undisplayableSelectedKpiMessage }}
      </birdz-alert>
    }

    <div>
      @if (isLoading === 0 && isHeavy && !isLoaded) {
        <div class="heavy-map-display">
          <div>{{ 'HEAVY_MAP_LOADING_INTERRUPTED' | transloco }}</div>
          <button matButton="filled" (click)="fetchMap()">
            {{ 'RELOAD' | transloco }}
          </button>
        </div>
      }
    </div>

    @if (hasNonGeocodedPds) {
      <birdz-alert type="warning" icon="warning">
        {{
          ((techno$ | async) === 'watermetering'
            ? 'MESSAGE_NON_GEOCODED_PDS'
            : (techno$ | async) === 'kapta'
              ? 'MESSAGE_NON_GEOCODED_KAPTA'
              : 'MESSAGE_NON_GEOCODED_SEWERIN'
          ) | transloco
        }}
      </birdz-alert>
    }

    <!-- Rich option template for the meter geocoder — defined here so it has access to component state -->
    <ng-template #meterOptionTpl let-opt>
      @let techno = techno$ | async;
      @let equipmentTranslationKey = techno === 'sewerin' ? 'SEWERIN' : techno === 'kapta' ? 'KAPTA' : 'METER';
      <div class="option">
        @if (isBirdzAdmin$ | async) {
          <div class="option__pds">{{ opt.id }}</div>
        } @else {
          <div class="option__customer_pds">{{ opt.customer_pds_id }}</div>
        }
        <div class="option__meter">{{ equipmentTranslationKey | transloco }} {{ opt.equipment_id }}</div>
        <div class="option__module">{{ 'DEVICE' | transloco }} {{ opt.device_id }}</div>
      </div>
    </ng-template>

    <div class="map">
      <birdz-map
        id="supervision-kpi-map"
        [markerLayers]="mapLayers"
        [popupComponent]="popupComponent"
        [popupContext]="popupContext"
        [isLoading]="isLoading > 0"
        [isEmpty]="isLoaded && mapSource.getFeatures().length === 0"
        [extraGeocoders]="extraGeocoders"
        [searchResetToken]="searchVersion"
        [hasLegendMenu]="false"
      />
    </div>
    <div class="legend">
      @if (missingThresholdAlert) {
        <birdz-alert type="error" icon="error">
          {{ 'KPI_MAP_LEGEND.MISSING_THRESHOLD' | transloco }}
        </birdz-alert>
      }

      @for (mapLegendItem of mapLegend; track mapLegendItem) {
        <div
          class="legend__item"
          [class.disabled]="!mapLegendItem.toggled"
          style="--color: {{ mapLegendItem.color }}"
          (click)="toggleLegendState(mapLegendItem.id)"
        >
          {{ mapLegendItem.label }}
        </div>
      }
    </div>
  </div>
</birdz-card>
